var render = function () {
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "position-relative"
  }, [_c('select', _vm._g(_vm._b({
    class: _vm.$style.select,
    style: {
      background: _vm.changed ? _vm.changedColor : '#fff'
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('update', $event.target.value);
      }
    }
  }, 'select', _vm.$attrs, false), _vm.$listeners), [_vm.emptyText ? _c('option', {
    class: (_class = {}, _class[_vm.$style.gray] = true, _class),
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.emptyText))]) : _vm._e(), _vm.isObjectOption ? _vm._l(_vm.options, function (option) {
    return _c('option', {
      key: option[_vm.optionValue],
      domProps: {
        "value": option[_vm.optionValue],
        "selected": option[_vm.optionValue] === _vm.value
      }
    }, [_vm._v(_vm._s(option[_vm.optionText]))]);
  }) : _vm._e(), _vm.isStringOption || _vm.isNumberOption ? _vm._l(_vm.options, function (option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option,
        "selected": option === _vm.value
      }
    }, [_vm._v(_vm._s(option) + " ")]);
  }) : _vm._e()], 2), _c('BaseIcon', {
    class: _vm.$style.selectDownArrow,
    attrs: {
      "name": "chevron-down"
    }
  }), _c('div', {
    class: _vm.$style.errorContainer
  }, [_vm.error ? _c('p', {
    staticClass: "tag-text",
    class: _vm.$style.errorMessage
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }